const initialState = {};

const Reducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case "SAVE_AuthFunction":
      return { ...state, Function: payload };
    case "CLEAR":
      return initialState;
    default:
      return state;
  }
};

export default Reducer;
